import { FormattedTransactionObject } from "~/types";

export const compareTransactionPeriod = (
  a: FormattedTransactionObject,
  b: FormattedTransactionObject,
) => {
  if (a.details.year !== b.details.year) {
    return a.details.year - b.details.year;
  }
  return a.details.month - b.details.month;
};

export const compareTransactionCreatedAt = (
  a: FormattedTransactionObject,
  b: FormattedTransactionObject,
) => {
  const timestampA = new Date(a.details.createdAt).getTime();
  const timestampB = new Date(b.details.createdAt).getTime();
  return timestampA - timestampB;
};

export const compareTransactionUpdatedAt = (
  a: FormattedTransactionObject,
  b: FormattedTransactionObject,
) => {
  const timestampA = new Date(a.details.updatedAt).getTime();
  const timestampB = new Date(b.details.updatedAt).getTime();
  return timestampA - timestampB;
};

/** Period DESC, then createdAt DESC — default payment table order. */
export const defaultTransactionSort = (
  a: FormattedTransactionObject,
  b: FormattedTransactionObject,
) => {
  const periodCompare = compareTransactionPeriod(b, a);
  if (periodCompare !== 0) return periodCompare;
  return compareTransactionCreatedAt(b, a);
};
